import React from 'react';
import { Search, X } from 'lucide-react';
import Spinner from './Spinner';

/**
 * Reusable, premium styled Search Input field.
 */
export default function SearchInput({
  value,
  onChange,
  onClear,
  placeholder = 'Search...',
  loading = false,
  className = '',
  style = {},
  ...props
}) {
  return (
    <div className={`search-input-container ${className}`} style={{ position: 'relative', display: 'flex', alignItems: 'center', width: '100%', ...style }}>
      <Search size={14} className="search-input-icon" style={{ position: 'absolute', left: 12, color: 'var(--text-muted)', pointerEvents: 'none' }} />
      <input
        type="text"
        className="input search-input-field"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        style={{ 
          paddingLeft: 36, 
          paddingRight: (loading || value) ? 36 : 12, 
          width: '100%', 
          height: 38, 
          fontSize: '13.5px',
          fontFamily: "'Outfit', sans-serif"
        }}
        {...props}
      />
      <div className="search-input-actions" style={{ position: 'absolute', right: 12, display: 'flex', alignItems: 'center' }}>
        {loading ? (
          <Spinner size={14} />
        ) : (
          value && onClear && (
            <button
              type="button"
              onClick={onClear}
              aria-label="Clear search"
              style={{ 
                background: 'none', 
                border: 'none', 
                padding: 2, 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                cursor: 'pointer', 
                color: 'var(--text-muted)',
                borderRadius: '50%',
                transition: 'background 0.15s, color 0.15s'
              }}
              onMouseOver={e => {
                e.currentTarget.style.color = 'var(--text-primary)';
                e.currentTarget.style.background = 'rgba(0,0,0,0.05)';
              }}
              onMouseOut={e => {
                e.currentTarget.style.color = 'var(--text-muted)';
                e.currentTarget.style.background = 'transparent';
              }}
            >
              <X size={14} />
            </button>
          )
        )}
      </div>
    </div>
  );
}
